import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../data";

const POINTS = [
  "Petugas terseleksi & terlatih",
  "Harga transparan tanpa biaya tersembunyi",
  "Fleksibel pilih hari, durasi, dan gender petugas",
  "Garansi kepuasan di setiap kunjungan",
];

export default function WhyUs() {
  return (
    <section className="section why">
      <div className="container why-grid">
        <Reveal className="why-visual">
          <div className="why-frame">
            <img src={IMAGES.teamPortrait} alt="Tim petugas antarcleaning yang ramah dan profesional" />
            <div className="stat-card">
              <strong>100%</strong>
              <span>
                fokus pada
                <br />
                kepuasan Anda
              </span>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <span className="eyebrow">Kenapa antarcleaning</span>
          <h2 className="h2">
            Detail kecil,
            <br />
            <em>beda besar.</em>
          </h2>
          <p className="why-text">
            Kami percaya rumah yang bersih dimulai dari tim yang peduli. Setiap petugas antarcleaning dilatih untuk bekerja teliti, sopan, dan
            menghargai ruang pribadi Anda.
          </p>
          <ul className="checks">
            {POINTS.map((p) => (
              <li key={p}>
                <span className="check-dot">
                  <Check size={14} />
                </span>
                {p}
              </li>
            ))}
          </ul>
          <a href="#pesan" className="btn-outline" data-testid="why-booking-link">
            Rasakan bedanya <ArrowRight size={15} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
